
import { MediaQueryStyleSheet } from 'react-native-responsive';
import { PALETTE } from '../../../constants';

export default MediaQueryStyleSheet.create(
  {
    tabStyle: {
      padding: 5,
      color: PALETTE.secondaryText,
    },
    tabStyleSelected: {
      padding: 5,
      color: PALETTE.primaryActive,
    },
    sortingHeaderStyle: {
      paddingTop: 10,
      paddingBottom: 10,
    },
    container: {
      flex: 1,
      paddingHorizontal: 5,
    },
    accordionMinusIconStyle: {
      marginTop: 10
    },
    headerContainer: {
      flex: 1,
      flexDirection: 'row',
      padding: 15,
      marginTop: 10,
    },
    headerDocument: {
      flex: 0.5,
    },
    headerDate: {
      flex: 0.5,
    },
    accordionTitleContainer: {
      flex: 1,
      flexDirection: 'column',
    },
    accordionTitleFirstRow: {
      flex: 1,
      flexDirection: 'row',
      paddingBottom: 10,
      minHeight: 42,
    },
    accordionTitleFirstColumn: {
      flex: 0.5,
      flexDirection: 'column',
    },
    accordionTitleSecondColumn: {
      flex: 0.5,
      flexDirection: 'column',
    },
    accordionTitleText: {
      color: 'white',
    },
    accordionDetailContainer: {
      flex: 1,
      paddingLeft: 12,
      paddingTop: 10,
    },
    accordionDetailText: {
      flex: 1,
      flexDirection: 'row',
      paddingBottom: 10,
      minHeight: 21,
    },
    viewPDFButton: {
      flex: 1,
      flexDirection: 'row',
      borderRadius: 2,
      height: 35,
      backgroundColor: PALETTE.primaryActive,
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      width: 150,
      alignSelf: 'flex-end',
    },
  }
);
